import type { PaymentMethod } from '@/api/transactions/use-trading-account-transactions';

export function isManualPaymentMethod(pm: PaymentMethod | undefined): boolean {
    if (!pm) return false;
    if (pm.method_type === 'manual') return true;
    if (pm.method_type === 'processor') return false;
    return !pm.supports_processors;
}
